import { createBrowserRouter, Outlet, ScrollRestoration } from "react-router-dom";
import LoginPage from "../pages/auth/LoginPage";
import LoginMercuryMotivationPage from "../pages/auth/LoginMercuryMotivation";
import RegisterPage from "../pages/auth/RegisterPage";
import RequestPasswordResetPage from "../pages/auth/RequestPasswordResetPage";
import PasswordResetPage from "../pages/auth/PasswordResetPage";
import DashboardPage from "../pages/admin/DashboardPage";
import DashboardPerusahaanPage from "../pages/admin/dashboard-perusahaan/IndexPage";
import DashboardKoordinatorPage from "../pages/admin/DashboardKoordinatorPage";
import RouteGuest from "../components/fragments/RouteGuest";
import { AuthProvider } from "../contexts/AuthContext";

import RegistrationIndexPage from "../pages/admin/registration/IndexPage";
import RegistrationRecapIndexPage from "../pages/admin/registration/recap/IndexPage";
import RegistrationValidIndexPage from "../pages/admin/registration/valid/IndexPage";
import RegistrationDashboardPage from "../pages/admin/registration/DashboardPage";
import RegistrationDetailPage from "../pages/admin/registration/DetailPage";
import CompanyRegistrationIndexPage from "../pages/admin/registration/company/IndexPage";
import CompanyRegistrationAddSKPage from "../pages/admin/registration/manualsk/AddSKPage";
import RegistrationTasksIndexPage from "../pages/admin/registration/tasks/IndexPage";

import RecomendationDashboardPage from "../pages/admin/recomendation/DashboardPage";
import RecomendationIndexPage from "../pages/admin/recomendation/IndexPage";
import RecomendationDetailPage from "../pages/admin/recomendation/DetailPage";
import RecomendationSearchIndexPage from "../pages/admin/recomendation/search/IndexPage";
import RecomendationManualSKPage from "../pages/admin/recomendation/manualsk/AddSKPage";
import RecomendationTasksIndexPage from "../pages/admin/recomendation/tasks/IndexPage";

import NotificationDashboardPage from "../pages/admin/notification/DashboardPage";
import NotificationIndexPage from "../pages/admin/notification/IndexPage";
import NotificationDetailPage from "../pages/admin/notification/DetailPage";
import NotificationImportVerficationDraftPage from "../pages/admin/notification/ImportVerficationDraftPage";
import NotificationImportApprovalDraftPage from "../pages/admin/notification/ImportApprovalDraftPage";
import NotificationImportEcDraftPage from "../pages/admin/notification/ImportEcDraftPage";

import CompanyReportStorageIndexPage from "../pages/admin/report/storage/company/IndexPage";
import CompanyReportStorageDetailPage from "../pages/admin/report/storage/company/DetailPage";
import AdminReportStorageIndexPage from "../pages/admin/report/storage/admin/IndexPage";
import AdminReportStorageDetailPage from "../pages/admin/report/storage/admin/DetailPage";

import CompanyReportTransportVehicleIndexPage from "../pages/admin/report/transport/VehicleIndexPage";
import CompanyReportTransportVehicleAddPage from "../pages/admin/report/transport/VehicleAddPage";
import CompanyReportTransportVehicleDetailPage from "../pages/admin/report/transport/VehicleDetailPage";
import CompanyReportTransportVehicleCreatePage from "../pages/admin/report/transport/VehicleCreatePage";
import CompanyReportTransportVehicleEditPage from "../pages/admin/report/transport/VehicleEditPage";

import CompanyReportProductionIndexPage from "../pages/admin/report/production/IndexPage";

import CompanyReportDistributionIndexPage from "../pages/admin/report/distribution/IndexPage";
import CompanyReportDistributionEditPage from "../pages/admin/report/distribution/EditPage";

import CompanyReportConsumptionIndexPage from "../pages/admin/report/consumption/IndexPage";
import CompanyReportConsumptionEditPage from "../pages/admin/report/consumption/EditPage";

import CompanyReportPurchaseIndexPage from "../pages/admin/report/purchase/IndexPage";
import CompanyReportPurchaseEditPage from "../pages/admin/report/purchase/EditPage";

import CompanyReportPreviewIndexPage from "../pages/admin/report/preview/IndexPage";

import CarbonCopyIndexPage from "../pages/admin/carbon-copy/IndexPage";
import CustomerIndexPage from "../pages/admin/master-data/customer/IndexPage";
import TransporterIndexPage from "../pages/admin/master-data/transporter/IndexPage";
import SupplierIndexPage from "../pages/admin/master-data/supplier/IndexPage";
import MaterialIndexPage from "../pages/admin/master-data/material/IndexPage";
import OfficialIndexPage from "../pages/admin/master-data/official/IndexPage";
import VehicleIndexPage from "../pages/admin/master-data/vehicle/IndexPage";

import HomePage from "../pages/landing-page/home";
import BeritaPage from "../pages/landing-page/berita";
import ArticlePage from "../pages/landing-page/article";
import GaleriPage from "../pages/landing-page/galeri";
import CompanyIndexPage from "../pages/admin/master-data/company/IndexPage";
import DocumentPage from "../pages/landing-page/document";
import FaqPage from "../pages/landing-page/faq";
import PeriodIndexPage from "../pages/admin/master-data/period/IndexPage";
import AsalMuatIndexPage from "../pages/admin/master-data/asal-muat/IndexPage";
import TujuanBongkarIndexPage from "../pages/admin/master-data/tujuang-bongkar/IndexPage";
import PelabuhanBongkarIndexPage from "../pages/admin/master-data/pelabuhan-bongkar/IndexPage";
import NewsIndexPage from "../pages/admin/cms/news/IndexPage";
import ArticleIndexPage from "../pages/admin/cms/article/IndexPage";
import DocumentIndexPage from "../pages/admin/cms/document/IndexPage";
import EventIndexPage from "../pages/admin/cms/event/IndexPage";

import PelaporanPenyimpananGrafik from "../pages/admin/Pelaporan/DashboardPenyimpanan/GrafikPenyimpanan";
import MapsPenyimpanan from "../pages/admin/Pelaporan/DashboardPenyimpanan/MapsPenyimpanan";
import DistribusiGrafik from "../pages/admin/Pelaporan/DashboardDistribusi/GrafikDistribusi";
import DistribuiMaps from "../pages/admin/Pelaporan/DashboardDistribusi/MapsDistribusi";
import DistribusiPencarian from "../pages/admin/Pelaporan/DashboardDistribusi/PencarianDistribusi";
import ImportGrafik from "../pages/admin/Pelaporan/DashboardImport/GrafikImport";
import ImportMaps from "../pages/admin/Pelaporan/DashboardImport/MapsImport";
import ImportPencarian from "../pages/admin/Pelaporan/DashboardImport/PencarianImport";

import ReportDashboardPage from "../pages/admin/report/DashboardPage";
import IndexAdminStokB3 from "../pages/admin/stokB3/admin/IndexPage";
import IndexUserStokB3 from "../pages/admin/stokB3/user/IndexPage";
import IndexRiwayatPenghapusanStokB3 from "../pages/admin/stokB3/riwayatPenghapusan/IndexPage";
import FaqIndexPage from "../pages/admin/cms/faq/IndexPage";
import CategoryPage from "../pages/admin/cms/category/IndexPage";
import GalleryPage from "../pages/admin/cms/gallery/IndexPage";

import MercuryMonitoringLandingPage from "../pages/landing-page/mercuryMonitoring";
import WilayahPertambanganRakyat from "../pages/admin/wpr/IndexPage";
import MercuryMonitoringIndex from "../pages/admin/merkuri/IndexPage";
import UnauthorizedPage from "../pages/admin/UnauthorizedPage";
import ProtectedRoute from "../services/protectedRoute";
import UserManagementPage from "../pages/admin/users/IndexPage";
import ProdusenPencarian from "../pages/admin/report/produsen/ProdusenPencarian";
import ProdusenGrafik from "../pages/admin/report/produsen/ProdusenGrafik";
import PengangkutanGrafik from "../pages/admin/report/pengangkutan/PengangkutanGrafik";
import PengangkutanPencarian from "../pages/admin/report/pengangkutan/PengangkutanPencarian";
import PengangkutanMaps from "../pages/admin/report/pengangkutan/MapsPengangkutan";
import PenggunaanGrafik from "../pages/admin/report/use/graph/IndexPage";
import PenggunaanPencarian from "../pages/admin/report/use/filter/IndexPage";
import PenggunaanPeta from "../pages/admin/report/use/map/IndexPage";
import ProdusenPeta from "../pages/admin/report/produsen/ProdusenPeta";

import ProfilePage from "../pages/admin/profile/profile";
import RolesAccess from "../enums/roles";
import ReadPage from "../pages/landing-page/read";
import FormatNomorSuratPage from "../pages/admin/nomor-surat/IndexPage";
import TicketPage from "../pages/admin/ticket/indexPage";
import DetailPage from "../pages/admin/ticket/DetailPage";
import AnnouncementPage from "../pages/admin/announcement/IndexPage";
import UploadAndValidateTable from "../pages/admin/merkuri/BulkUploadMerkuri";
import B3Database from "../pages/landing-page/data-bahan-b3";
import JariEmas from "../pages/landing-page/jari-emas";
import IndexPage from "../pages/admin/recomendation/user/IndexPage";
import UploadExcelPage from "../pages/admin/recomendation/user/DetailPage";
import UserPTSPPage from "../pages/auth/UserPTSPPage";
import TableReportReview from "../pages/admin/report/review/DetailPengelolaanPage";
import TableReportTransportReview from "../pages/admin/report/review/DetailPengangkutanPage";
import IndexReviewPage from "../pages/admin/report/review/IndexPage";
import IndexUserReviewPage from "../pages/admin/report/review/IndexUserPage";
import UseReviewPage from "../pages/admin/users/ReviewPage";
import ErrorUnauthenticatedNotFound from "../components/fragments/errorUnAuthenticatedPage";
import ErrorAuthenticatedNotFound from "../components/fragments/errorAuthenticatedPage";
import InformasiPage from "../pages/landing-page/informasi";
import InformasiTopikPage from "../pages/landing-page/informasi-topik";
import SimpelLoginPage from "../pages/auth/SimpelLoginPage";

export const ROOT_PATH = "/";
export const INFORMASI_PATH = "/informasi";
export const BERITA_PATH = "/berita";
export const ARTICLE_PATH = "/artikel";
export const ARSIP_PATH = "/arsip";
export const FAQ_PATH = "/faq";
export const GALERI_PATH = "/galeri";
export const MONITORING_MERCURY_PATH = "/pemantauan-merkuri";
export const BERITA_READ_PATH = "/berita/:slug";
export const ARTICLE_READ_PATH = "/artikel/:slug";
export const DATABASE_B3_PATH = "/database-b3";
export const DATABASE_B3_DETAIL_PATH = "/database/b3/:id";
export const JARI_EMAS_PATH = "/jari-emas";

export const LOGIN_PATH = "/masuk";
export const LOGIN_MERCURY_MOTIVASION_PATH = "/motivasi-merkuri/masuk";
export const REGISTER_PATH = "/daftar";
export const REGISTER_PTSP_PATH = "/daftar-ptsp";
export const FORGOT_PASSWORD_PATH = "/lupa-sandi/formulir";
export const RESET_PASSWORD_PATH = "/lupa-sandi/atur-ulang";
export const SIMPEL_LOGIN_PATH = "/simpel/login";

export const DASHBOARD_PATH = "/admin/dasbor";
export const DASHBOARD_PERUSAHAAN_PATH = "/admin/dasbor-perusahaan";
export const KOORDINATOR_DASHBOARD_PATH = "/admin/dasbor/koordinator";
export const PELAPORAN_DASHBOARD_PATH = "/admin/dasbor/pelaporan";
export const PELAPORAN_PENYIMPANAN_GRAFIK_PATH = "/admin/dasbor/pelaporanPenyimpanan/grafik";
export const PELAPORAN_PENYIMPANAN_MAPS_PATH = "/admin/dasbor/pelaporanPenyimpanan/maps";

export const PELAPORAN_PENGGUNAAN_GRAFIK = "/admin/pelaporan/penggunaan/grafik";
export const PELAPORAN_PENGGUNAAN_PENCARIAN = "/admin/pelaporan/penggunaan/pencarian";
export const PELAPORAN_PENGGUNAAN_PETA = "/admin/pelaporan/penggunaan/peta";

export const PELAPORAN_PENGANGKUTAN_GRAFIK = "/admin/pelaporan/pengangkutan/grafik";
export const PELAPORAN_PENGANGKUTAN_PENCARIAN = "/admin/pelaporan/pengangkutan/pencarian";
export const PELAPORAN_PENGANGKUTAN_MAPS = "/admin/pelaporan/pengangkutan/maps";

export const PELAPORAN_DITRIBUSI_GRAFIK_PATH = "/admin/pelaporan/distribusi/grafik";
export const PELAPORAN_DISTRIBUI_MAPS_PATH = "/admin/pelaporan/distribusi/maps";
export const PELAPORAN_DISTRIBUI_PENCARIAN_PATH = "/admin/pelaporan/distribusi/pencarian";

export const PELAPORAN_IMPORT_GRAFIK_PATH = "/admin/pelaporan/import/grafik";
export const PELAPORAN_IMPORT_MAPS_PATH = "/admin/pelaporan/import/maps";
export const PELAPORAN_IMPORT_PENCARIAN_PATH = "/admin/pelaporan/import/pencarian";

export const REGISTRATION_DASHBOARD_PATH = "/admin/registrasi-b3/dasbor";
export const REGISTRATION_INDEX_PATH = "/admin/registrasi-b3/daftar";
export const REGISTRATION_DETAIL_PATH = "/admin/registrasi-b3/daftar/:id";
export const COMPANY_REGISTRATION_INDEX_PATH = "/registrasi-b3/daftar";
export const COMPANY_REGISTRATION_ADDSK_PATH = "/registrasi-b3/addsk";
export const REGISTRATION_REKAP_PATH = "/admin/registrasi-b3/rekapitulasi";
export const VALIDATION_REGISTRATION_B3_PATH = "/registrasi-b3/validasib3";
export const TUGAS_SAYA_REGISTRASI_PATH = "/admin/registrasi-b3/tugas-saya";

export const RECOMENDATION_DASHBOARD_PATH = "/admin/rekomendasi-b3/dasbor";
export const RECOMENDATION_INDEX_PATH = "/admin/rekomendasi-b3/daftar";
export const RECOMENDATION_CREATE_PATH = "/admin/rekomendasi-b3/tambah";
export const RECOMENDATION_DETAIL_PATH = "/admin/rekomendasi-b3/daftar/:id";
export const USER_RECOMENDATION_INDEX_PATH = "/rekomendasi-b3/daftar";
export const USER_ADD_RECOMENDATION_PATH = "/rekomendasi-b3/tambah";
export const SEARCH_RECOMENDATION_PATH = "/rekomendasi-b3/search";
export const SK_MANUAL_RECOMENDATION_PATH = "/rekomendasi-b3/manualsk";
export const TUGAS_SAYA_REKOMENDASI_PATH = "/admin/rekomendasi-b3/tugas-saya";

export const NOTIFICATION_DASHBOARD_PATH = "/admin/notifikasi/dasbor";
export const NOTIFICATION_INDEX_PATH = "/admin/notifikasi/daftar";
export const NOTIFICATION_DETAIL_PATH = "/admin/notifikasi/daftar/:id";
export const NOTIFICATION_IMPORT_VERIFICATION_PATH = "/admin/notifikasi/draft-surat-kebenaran-impor/:notificationId";
export const NOTIFICATION_IMPORT_APPROVAL_PATH = "/admin/notifikasi/draft-surat-persetujuan-impor/:notificationId";
export const NOTIFICATION_IMPORT_EC_PATH = "/admin/notifikasi/draft-surat-explicit-consent/:notificationId";

export const ADMIN_REPORT_STORAGE = "/admin/pelaporan/penyimpanan-b3/daftar";
export const ADMIN_REPORT_STORAGE_DETAIL = "/admin/pelaporan/penyimpanan-b3/daftar/:id";
export const COMPANY_REPORT_STORAGE = "/pelaporan/penyimpanan-b3/daftar";
export const COMPANY_REPORT_STORAGE_DETAIL = "/pelaporan/penyimpanan-b3/daftar/:id";

export const REPORT_TRANSPORT_RECOMENDATION_VEHICLE_ADD = "/pelaporan/pengangkutan-b3/kendaraan/add";
export const REPORT_TRANSPORT_RECOMENDATION_VEHICLE_INDEX = "/pelaporan/pengangkutan-b3/kendaraan/daftar";
export const REPORT_TRANSPORT_RECOMENDATION_VEHICLE_DETAIL = "/pelaporan/pengangkutan-b3/kendaraan/daftar/:id";
export const REPORT_TRANSPORT_RECOMENDATION_VEHICLE_CREATE = "/pelaporan/pengangkutan-b3/kendaraan/tambah/:detailId";
export const REPORT_TRANSPORT_RECOMENDATION_VEHICLE_EDIT = "/pelaporan/pengangkutan-b3/kendaraan/ubah/:detailId/:id";

export const REPORT_PRODUCTION_MATERIAL = "/pelaporan/bahan-b3/produksi/daftar";

export const REPORT_DISTRIBUTION_MATERIAL_INDEX = "/pelaporan/bahan-b3/distribusi/daftar";
export const REPORT_DISTRIBUTION_MATERIAL_EDIT = "/pelaporan/bahan-b3/distribusi/ubah/:id";

export const REPORT_CONSUMPTION_MATERIAL_INDEX = "/pelaporan/bahan-b3/penggunaan/daftar";
export const REPORT_CONSUMPTION_MATERIAL_EDIT = "/pelaporan/bahan-b3/penggunaan/ubah/:id";

export const REPORT_PURCHASE_MATERIAL_INDEX = "/pelaporan/bahan-b3/pembelian/daftar";
export const REPORT_PURCHASE_MATERIAL_EDIT = "/pelaporan/bahan-b3/pembelian/ubah/:id";

export const REPORT_PREVIEW_INDEX = "/pelaporan/pratinjau/daftar";
export const REPORT_TRANSPORT_PREVIEW_INDEX = "/pelaporan/pratinjau/pengangkutan/daftar";

export const REPORT_PRODUCER_INDEX = "/admin/pelaporan/produsen-b3";
export const PELAPORAN_PRODUSEN_PENCARIAN = "/admin/pelaporan/produsen/pencarian";
export const PELAPORAN_PRODUSEN_GRAFIK = "/admin/pelaporan/produsen/grafik";
export const PELAPORAN_PRODUSEN_PETA = "/admin/pelaporan/produsen/peta";

export const CARBON_COPY_INDEX_PATH = "/admin/utama/tembusan";
export const MATERIAL_INDEX_PATH = "/admin/utama/bahan-b3";
export const OFFICIAL_INDEX_PATH = "/admin/utama/pejabat";
export const COMPANY_INDEX_PATH = "/admin/utama/perusahaan";
export const PERIOD_INDEX_PATH = "/admin/utama/periode";
export const ASAL_MUAT_INDEX_PATH = "/admin/utama/perusahaan-asal-muat";
export const TUJUAN_BONGKAR_INDEX_PATH = "/admin/utama/perusahaan-tujuan-bongkar";
export const CUSTOMER_INDEX_PATH = "/admin/utama/perusahaan-customer";
export const TRANSPORTER_INDEX_PATH = "/admin/utama/perusahaan-transporter";
export const PELABUHAN_BONGKAR_INDEX_PATH = "/admin/utama/pelabuhan-bonkar";
export const SUPPLIER_INDEX_PATH = "/admin/utama/perusahaan-supplier";
export const VEHICLE_INDEX_PATH = "/admin/utama/kendaraan";

export const WPR_INDEX_PATH = "/admin/merkuri/wpr";
export const MERKURI_MONITORING_INDEX_PATH = "/admin/merkuri/monitoring";
export const MERKURI_MONITORING_BULK_PATH = "/admin/merkuri/monitoring/bulk";

export const CMS_NEWS_PATH = "/admin/cms/berita";
export const CMS_ARTICLE_PATH = "/admin/cms/artikel";
export const CMS_DOCUMENT_PATH = "/admin/cms/dokumen";
export const CMS_EVENT_PATH = "/admin/cms/event";
export const CMS_CATEGORY_PATH = "/admin/cms/category";
export const CMS_GALLERY_PATH = "/admin/cms/gallery";
export const CMS_FAQ_PATH = "/admin/cms/faq";

export const STOK_B3_INDEX_ADMIN_PATH = "/admin/gudang/stok-b3";
export const STOK_B3_INDEX_USER_PATH = "/gudang/stok-b3";
export const STOK_B3_RIWAYAT_PENGHAPUSAN_PATH = "/admin/gudang/stok-b3/riwayat-penghapusan";

export const UNAUTHORIZED_PATH = "/unauthorized";

export const USERS_MANAGEMENT_INDEX_PATH = "/admin/user-management";

export const USER_PROFILE = "/user/profile";

export const NOMOR_SURAT_MANAGEMENT_INDEX_PATH = "/admin/nomor-surat";

export const TICKET_MANAGEMENT_INDEX_PATH = "/admin/ticket";

export const TICKET_DETAIL_PATH = "/admin/ticket/:id";

export const ANNOUNCEMENT_INDEX_PATH = "/admin/announcement";

export const REVIEW_PELAPORAN_INDEX = "/pelaporan/review";
export const USER_REVIEW_PELAPORAN_INDEX = "/pelaporan/user/review";
export const DETAIL_REVIEW_PELAPORAN_PENGELOLAAN = "/pelaporan/bahan-b3/review/pengelolaan/:companyId/:periodId";
export const DETAIL_REVIEW_PELAPORAN_PENGANGKUTAN = "/pelaporan/bahan-b3/review/pengangkutan/:companyId/:periodId";

export const REVIEW_NEW_USER = "/admin/review-user-management";

const AppLayout = () => (
  <>
    <ScrollRestoration />
    <Outlet />
  </>
);

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: ROOT_PATH, element: <HomePage /> },
      { path: INFORMASI_PATH, element: <InformasiPage /> },
      { path: `${INFORMASI_PATH}/:topik`, element: <InformasiTopikPage /> },
      { path: `${INFORMASI_PATH}/:topik/:konvensi`, element: <InformasiTopikPage /> },
      { path: BERITA_PATH, element: <BeritaPage /> },
      { path: BERITA_READ_PATH, element: <ReadPage /> },
      { path: ARTICLE_PATH, element: <ArticlePage /> },
      { path: ARTICLE_READ_PATH, element: <ReadPage /> },
      { path: ARSIP_PATH, element: <DocumentPage /> },
      { path: FAQ_PATH, element: <FaqPage /> },
      { path: DATABASE_B3_PATH, element: <B3Database /> },
      { path: JARI_EMAS_PATH, element: <JariEmas /> },
      { path: MONITORING_MERCURY_PATH, element: <MercuryMonitoringLandingPage /> },
      { path: GALERI_PATH, element: <GaleriPage /> },
      { path: LOGIN_PATH, element: <LoginPage /> },
      { path: SIMPEL_LOGIN_PATH, element: <SimpelLoginPage /> },
      { path: LOGIN_MERCURY_MOTIVASION_PATH, element: <LoginMercuryMotivationPage /> },
      { path: REGISTER_PATH, element: <RegisterPage /> },
      { path: FORGOT_PASSWORD_PATH, element: <RequestPasswordResetPage /> },
      { path: RESET_PASSWORD_PATH, element: <PasswordResetPage /> },
      { path: REGISTER_PTSP_PATH, element: <UserPTSPPage /> },
      { path: "*", element: <ErrorUnauthenticatedNotFound /> },
    ],
  },
  {
    element: <AuthProvider />,
    children: [
      { path: UNAUTHORIZED_PATH, element: <UnauthorizedPage /> },
      { path: "*", element: <ErrorAuthenticatedNotFound /> },
      {
        element: <RouteGuest />,
        children: [
          { path: LOGIN_PATH, element: <LoginPage /> },
          { path: REGISTER_PATH, element: <RegisterPage /> },
          { path: FORGOT_PASSWORD_PATH, element: <RequestPasswordResetPage /> },
          { path: RESET_PASSWORD_PATH, element: <PasswordResetPage /> },
        ],
      },
      {
        element: <AuthProvider />,
        children: [
          { path: UNAUTHORIZED_PATH, element: <UnauthorizedPage /> },
          {
            path: DASHBOARD_PATH,
            element: (
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            ),
          },
          {
            path: DASHBOARD_PERUSAHAAN_PATH,
            element: (
              <ProtectedRoute
                allowedRoles={[
                  RolesAccess.SUPER_ADMIN,
                  RolesAccess.PIC_PELAPORAN,
                  RolesAccess.DIREKTUR,
                  RolesAccess.KOORDINATOR,
                  RolesAccess.PENGELOLA,
                ]}
              >
                <DashboardPerusahaanPage />
              </ProtectedRoute>
            ),
          },
          {
            path: KOORDINATOR_DASHBOARD_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.KOORDINATOR, RolesAccess.SUPER_ADMIN]}>
                <DashboardKoordinatorPage />
              </ProtectedRoute>
            ),
          },

          {
            path: REGISTRATION_DASHBOARD_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_REGISTRASI, RolesAccess.SUPER_ADMIN, RolesAccess.KAB_SUBDIT_REGISTRASI, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR]}>
                <RegistrationDashboardPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REGISTRATION_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR]}>
                <RegistrationIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TUGAS_SAYA_REGISTRASI_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_REGISTRASI, RolesAccess.SUPER_ADMIN]}>
                <RegistrationTasksIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REGISTRATION_DETAIL_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_REGISTRASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR]}>
                <RegistrationDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: COMPANY_REGISTRATION_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA]}>
                <CompanyRegistrationIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: COMPANY_REGISTRATION_ADDSK_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA]}>
                <CompanyRegistrationAddSKPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REGISTRATION_REKAP_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR]}>
                <RegistrationRecapIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: VALIDATION_REGISTRATION_B3_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA]}>
                <RegistrationValidIndexPage />
              </ProtectedRoute>
            ),
          },

          {
            path: RECOMENDATION_DASHBOARD_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN, RolesAccess.KAB_SUBDIT_REKOMENDASI, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR]}>
                <RecomendationDashboardPage />
              </ProtectedRoute>
            ),
          },
          {
            path: RECOMENDATION_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR]}>
                <RecomendationIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TUGAS_SAYA_REKOMENDASI_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN]}>
                <RecomendationTasksIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: RECOMENDATION_DETAIL_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KOORDINATOR]}>
                <RecomendationDetailPage />
              </ProtectedRoute>
            ),
          },
          //RecomendationAddSKIndexPage
          {
            path: SK_MANUAL_RECOMENDATION_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA]}>
                <RecomendationManualSKPage />
              </ProtectedRoute>
            ),
          },
          {
            path: SEARCH_RECOMENDATION_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA]}>
                <RecomendationSearchIndexPage />
              </ProtectedRoute>
            ),
          },


          {
            path: NOTIFICATION_DASHBOARD_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationDashboardPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.PENGELOLA]}>
                <NotificationIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_DETAIL_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.PENGELOLA]}>
                <NotificationDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_IMPORT_VERIFICATION_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationImportVerficationDraftPage />
              </ProtectedRoute>
            ),
          },

          {
            path: NOTIFICATION_DASHBOARD_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationDashboardPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_DETAIL_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_IMPORT_VERIFICATION_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationImportVerficationDraftPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_IMPORT_APPROVAL_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationImportApprovalDraftPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NOTIFICATION_IMPORT_EC_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_NOTIFIKASI, RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]}>
                <NotificationImportEcDraftPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ADMIN_REPORT_STORAGE,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_PELAPORAN, RolesAccess.SUPER_ADMIN]}>
                <AdminReportStorageIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ADMIN_REPORT_STORAGE_DETAIL,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_PELAPORAN, RolesAccess.SUPER_ADMIN]}>
                <AdminReportStorageDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: COMPANY_REPORT_STORAGE,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportStorageIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: COMPANY_REPORT_STORAGE_DETAIL,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportStorageDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_TRANSPORT_RECOMENDATION_VEHICLE_INDEX,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
                <CompanyReportTransportVehicleIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_TRANSPORT_RECOMENDATION_VEHICLE_ADD,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportTransportVehicleAddPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_TRANSPORT_RECOMENDATION_VEHICLE_DETAIL,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportTransportVehicleDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_TRANSPORT_RECOMENDATION_VEHICLE_CREATE,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportTransportVehicleCreatePage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_TRANSPORT_RECOMENDATION_VEHICLE_EDIT,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportTransportVehicleEditPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_PRODUCTION_MATERIAL,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
                <CompanyReportProductionIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_DISTRIBUTION_MATERIAL_INDEX,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
                <CompanyReportDistributionIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_DISTRIBUTION_MATERIAL_EDIT,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportDistributionEditPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_CONSUMPTION_MATERIAL_INDEX,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
                <CompanyReportConsumptionIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORT_CONSUMPTION_MATERIAL_EDIT,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
                <CompanyReportConsumptionEditPage />
              </ProtectedRoute>
            ),
          },

          {
            path: CARBON_COPY_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI]}>
                <CarbonCopyIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: OFFICIAL_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI]}>
                <OfficialIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MATERIAL_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI]}>
                <MaterialIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: VEHICLE_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REKOMENDASI]}>
                <VehicleIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: COMPANY_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN]}>
                <CompanyIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: PERIOD_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
                <PeriodIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ASAL_MUAT_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
                <AsalMuatIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TUJUAN_BONGKAR_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
                <TujuanBongkarIndexPage />
              </ProtectedRoute>
            ),
          },

          {
            path: CMS_NEWS_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
                <NewsIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: CMS_ARTICLE_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
                <ArticleIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: CMS_DOCUMENT_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
                <DocumentIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: CMS_EVENT_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
                <EventIndexPage />
              </ProtectedRoute>
            ),
          },
          // { path: CMS_EVENT_PATH, element: <EventIndexPage /> },
          {
            path: CMS_GALLERY_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
                <GalleryPage />
              </ProtectedRoute>
            ),
          },
          {
            path: CMS_FAQ_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
                <FaqIndexPage />
              </ProtectedRoute>
            ),
          },
          {
            path: CMS_CATEGORY_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
                <CategoryPage />
              </ProtectedRoute>
            ),
          },

          { path: PELAPORAN_DASHBOARD_PATH, element: <ReportDashboardPage /> },
          { path: PELAPORAN_PENYIMPANAN_GRAFIK_PATH, element: <PelaporanPenyimpananGrafik /> },
          { path: PELAPORAN_PENYIMPANAN_MAPS_PATH, element: <MapsPenyimpanan /> },

          { path: PELAPORAN_DITRIBUSI_GRAFIK_PATH, element: <DistribusiGrafik /> },
          { path: PELAPORAN_DISTRIBUI_MAPS_PATH, element: <DistribuiMaps /> },
          { path: PELAPORAN_DISTRIBUI_PENCARIAN_PATH, element: <DistribusiPencarian /> },

          { path: PELAPORAN_IMPORT_GRAFIK_PATH, element: <ImportGrafik /> },
          { path: PELAPORAN_IMPORT_MAPS_PATH, element: <ImportMaps /> },
          { path: PELAPORAN_IMPORT_PENCARIAN_PATH, element: <ImportPencarian /> },

          { path: PELAPORAN_PRODUSEN_PENCARIAN, element: <ProdusenPencarian /> },
          { path: PELAPORAN_PRODUSEN_GRAFIK, element: <ProdusenGrafik /> },
          { path: PELAPORAN_PRODUSEN_PETA, element: <ProdusenPeta /> },

          { path: PELAPORAN_PENGGUNAAN_GRAFIK, element: <PenggunaanGrafik /> },
          { path: PELAPORAN_PENGGUNAAN_PENCARIAN, element: <PenggunaanPencarian /> },
          { path: PELAPORAN_PENGGUNAAN_PETA, element: <PenggunaanPeta /> },

          { path: PELAPORAN_PENGANGKUTAN_GRAFIK, element: <PengangkutanGrafik /> },
          { path: PELAPORAN_PENGANGKUTAN_PENCARIAN, element: <PengangkutanPencarian /> },
          { path: PELAPORAN_PENGANGKUTAN_MAPS, element: <PengangkutanMaps /> },

          { path: STOK_B3_INDEX_ADMIN_PATH, element: <IndexAdminStokB3 /> },
          { path: STOK_B3_INDEX_USER_PATH, element: <IndexUserStokB3 /> },
          {
            path: STOK_B3_RIWAYAT_PENGHAPUSAN_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN]}>
                <IndexRiwayatPenghapusanStokB3 />
              </ProtectedRoute>
            ),
          },

          { path: WPR_INDEX_PATH, element: <WilayahPertambanganRakyat /> },
          { path: MERKURI_MONITORING_INDEX_PATH, element: <MercuryMonitoringIndex /> },

          {
            path: USERS_MANAGEMENT_INDEX_PATH,
            element: (
              <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_USER]}>
                <UserManagementPage />
              </ProtectedRoute>
            ),
          },

          { path: USER_PROFILE, element: <ProfilePage /> },
        ],
      },
      {
        path: REPORT_PURCHASE_MATERIAL_INDEX,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
            <CompanyReportPurchaseIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: REPORT_PURCHASE_MATERIAL_EDIT,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]}>
            <CompanyReportPurchaseEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: REPORT_PREVIEW_INDEX,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
            <CompanyReportPreviewIndexPage />
          </ProtectedRoute>
        ),
      },

      {
        path: CARBON_COPY_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI]}>
            <CarbonCopyIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: OFFICIAL_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI]}>
            <OfficialIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: MATERIAL_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI]}>
            <MaterialIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: COMPANY_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REKOMENDASI, RolesAccess.PIC_REGISTRASI, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN]}>
            <CompanyIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: PERIOD_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]}>
            <PeriodIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ASAL_MUAT_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
            <AsalMuatIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: TUJUAN_BONGKAR_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
            <TujuanBongkarIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: CUSTOMER_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
            <CustomerIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: TRANSPORTER_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
            <TransporterIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: PELABUHAN_BONGKAR_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
            <PelabuhanBongkarIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: SUPPLIER_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN, RolesAccess.PENGELOLA]}>
            <SupplierIndexPage />
          </ProtectedRoute>
        ),
      },

      {
        path: CMS_NEWS_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
            <NewsIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: CMS_ARTICLE_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
            <ArticleIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: CMS_DOCUMENT_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
            <DocumentIndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: CMS_EVENT_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
            <EventIndexPage />
          </ProtectedRoute>
        ),
      },
      // { path: CMS_EVENT_PATH, element: <EventIndexPage /> },
      {
        path: CMS_GALLERY_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
            <GalleryPage />
          </ProtectedRoute>
        ),
      },
      {
        path: CMS_CATEGORY_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.PIC_CMS, RolesAccess.SUPER_ADMIN]}>
            <CategoryPage />
          </ProtectedRoute>
        ),
      },

      { path: WPR_INDEX_PATH, element: <WilayahPertambanganRakyat /> },
      { path: MERKURI_MONITORING_INDEX_PATH, element: <MercuryMonitoringIndex /> },
      { path: MERKURI_MONITORING_BULK_PATH, element: <UploadAndValidateTable /> },

      { path: USER_PROFILE, element: <ProfilePage /> },

      {
        path: NOMOR_SURAT_MANAGEMENT_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_NOTIFIKASI, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI]}>
            <FormatNomorSuratPage />
          </ProtectedRoute>
        ),
      },

      {
        path: TICKET_MANAGEMENT_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_KONSULTASI, RolesAccess.PENGELOLA]}>
            <TicketPage />
          </ProtectedRoute>
        ),
      },

      {
        path: TICKET_DETAIL_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_KONSULTASI, RolesAccess.PENGELOLA]}>
            <DetailPage />
          </ProtectedRoute>
        ),
      },

      {
        path: ANNOUNCEMENT_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_NOTIFIKASI, RolesAccess.PIC_PELAPORAN, RolesAccess.PIC_REGISTRASI, RolesAccess.PIC_REKOMENDASI]}>
            <AnnouncementPage />
          </ProtectedRoute>
        ),
      },

      {
        path: USER_RECOMENDATION_INDEX_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA]}>
            <IndexPage />
          </ProtectedRoute>
        ),
      },
      {
        path: USER_ADD_RECOMENDATION_PATH,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA]}>
            <UploadExcelPage />
          </ProtectedRoute>
        ),
      },
      {
        path: REVIEW_PELAPORAN_INDEX,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN]}>
            <IndexReviewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: DETAIL_REVIEW_PELAPORAN_PENGELOLAAN,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN]}>
            <TableReportReview />
          </ProtectedRoute>
        ),
      },
      {
        path: DETAIL_REVIEW_PELAPORAN_PENGANGKUTAN,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN]}>
            <TableReportTransportReview />
          </ProtectedRoute>
        ),
      },
      {
        path: USER_REVIEW_PELAPORAN_INDEX,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PENGELOLA, RolesAccess.PIC_PELAPORAN]}>
            <IndexUserReviewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: REVIEW_NEW_USER,
        element: (
          <ProtectedRoute allowedRoles={[RolesAccess.SUPER_ADMIN, RolesAccess.PIC_KONSULTASI]}>
            <UseReviewPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

export default router;
